import Error from './error'


export default function requiredWithoutFalse(value) {
  return ['', null, undefined].includes(value) ? <Error kind="required" /> : undefined
}
